import { render, staticRenderFns } from "./MunicipalityDetail.vue?vue&type=template&id=b48d7af4"
import script from "./MunicipalityDetail.vue?vue&type=script&lang=js"
export * from "./MunicipalityDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports